import angular from 'angular';

export default angular.module('cms.dashboard.hostsStatsChart', [])
    .component('mailHostStatsChart', {
        template: require('./hostsStatsChart.html'),
        controller: function(baConfig, layoutPaths, baUtil, $http, colorHelper, CONFIG)  {

          this.transparent = baConfig.theme.blur;
          let dashboardColors = baConfig.colors;

          let printChart = (data) => {

            this.allCount = data.all;

            this.doughnutData = {
              labels: data.labels,
              datasets: [
                {
                  data: data.data,
                  backgroundColor: [
                    colorHelper.tint(dashboardColors.danger, 15),
                    colorHelper.tint(dashboardColors.info, 15),
                    colorHelper.tint(dashboardColors.success, 15),
                    colorHelper.tint(dashboardColors.warning, 15),
                    colorHelper.tint(dashboardColors.primaryLight, 15)

                  ],
                  hoverBackgroundColor: [
                    colorHelper.shade(dashboardColors.danger, 15),
                    colorHelper.shade(dashboardColors.info, 15),
                    colorHelper.shade(dashboardColors.success, 15),
                    colorHelper.shade(dashboardColors.warning, 15),
                    colorHelper.shade(dashboardColors.primaryLight, 15)
                  ],
                  percentage: data.percentage
                }]
            };

            let ctx = document.getElementById('chart-area').getContext('2d');
              let hostsChart = new Chart(ctx, {
                type: 'doughnut',
                data: this.doughnutData,
                options: {
                  cutoutPercentage: 64,
                  responsive: true,
                  legend: {
                    display: false
                  },
                  elements: {
                    arc: {
                      borderWidth: 0
                    }
                  }
                }
            });

          };

          $http.get(CONFIG.API_URL+'/mailsStats/hosts').then(
            (response) => {
              printChart(response.data);
            }
          );

        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Mails/HostsStatsChart/HostsStatsChart.js